// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"36d9d30f","594":"09f22fb6"}[chunkId] + ".chunk.js";
};